module.exports = __webpack_public_path__ + "static/media/atea.18e5c401.svg";